L.rotateImageLayer = function (url, bounds, options) {
  return new L.RotateImageLayer(url, bounds, options)
}

function getRotateTransform(rotation) {
  if (rotation === 90) return "rotate(90deg) translateY(-100%)"
  else if (rotation === 180)
    return "rotate(180deg) translateY(-100%) translateX(-100%)"
  else if (rotation === 270) return "rotate(270deg) translateX(-100%)"
  return ""
}

L.RotateImageLayer = L.ImageOverlay.extend({
  options: { rotation: 0 },
  _animateZoom: function (e) {
    L.ImageOverlay.prototype._animateZoom.call(this, e)
    let img = this._image
    img.style[L.DomUtil.TRANSFORM] += getRotateTransform(this.options.rotation)
  },
  _reset: function () {
    L.ImageOverlay.prototype._reset.call(this)
    let img = this._image
    img.style[L.DomUtil.TRANSFORM] += getRotateTransform(this.options.rotation)
  },
})
